import { render, staticRenderFns } from "./HubProductMix.vue?vue&type=template&id=112ca293&scoped=true&"
import script from "./HubProductMix.vue?vue&type=script&lang=ts&"
export * from "./HubProductMix.vue?vue&type=script&lang=ts&"
import style0 from "./HubProductMix.vue?vue&type=style&index=0&id=112ca293&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112ca293",
  null
  
)

export default component.exports